// @flow

import React, { Component } from 'react';
import { Field, reduxForm, Form } from 'redux-form';
import { Button, Glyphicon, OverlayTrigger, Tooltip, Row, Col } from 'react-bootstrap';
import validate from './validatePageTwo';
import renderField from './renderField';
import asyncValidate from '../../YourSummaryPanel/form/asyncValidate';

type Props = {|
  handleSubmit: Function,
  handleBlur: Function,
  previousPage: Function,
  onSubmit: Function,
  children: number
|};

class RenderCheckbox extends Component {
  focusInput() {
    this.input.focus();
  }

  handleFieldBlur = () => {
    this.check.focus();
    this.check.blur();
  };

  handleOnClick = e => {
    this.props.handleBlur('flying');
    this.props.input.onFocus(e);
    this.check.focus();
    this.props.input.onBlur(e);
    this.check.blur();
  };
  handleOnFocus = e => {
    this.props.handleBlur('flying');
    this.props.input.onFocus(e);
    this.check.focus();
    this.props.input.onBlur(e);
    this.check.blur();
  };

  componentDidMount() {
    this.handleFieldBlur();
  }

  render() {
    const { input, label, type, meta: { touched, error, warning } } = this.props;
    return (
      <div>
        <input
          {...input}
          type={type}
          style={{ marginRight: '5px', position: '' }}
          ref={input => {
            this.check = input;
          }}
          onClick={this.handleOnClick}
          onFocus={this.handleOnFocus}
        />
        {label}

        <div style={{ color: 'red' }}>
          {touched && ((error && <span>{error}</span>) || (warning && <span>{warning}</span>))}
        </div>
      </div>
    );
  }
}

class WizardFormSecondPage extends Component<Props, State> {
  render() {
    const { handleSubmit, previousPage, onSubmit, handleBlur, help } = this.props;
    const planeFeedbackIcon = <Glyphicon glyph="plane" />;
    const homeFeedbackIcon = <Glyphicon glyph="home" />;
    const seatTypes = this.props.seatTypes.reduce((result, val) => {
      result.push({ value: val.seat_type_code, label: val.seat_type });
      return result;
    }, []);
    const childAges = this.props.childAges.reduce((result, val) => {
      result.push({ value: val.age, label: val.description });
      return result;
    }, []);
    let stopsFrom = seatTypes;
    let stopsTo = seatTypes;
    let times = seatTypes;
    if (this.props.transfers.shuttle.showFrom) {
      stopsFrom = this.props.transfers.shuttle.options.stopsFrom.reduce((result, val) => {
        result.push({ value: val.id, label: val.options });
        return result;
      }, []);
    }
    if (this.props.transfers.shuttle.showTo) {
      stopsTo = this.props.transfers.shuttle.options.stopsTo.reduce((result, val) => {
        result.push({ value: val.id, label: val.options });
        return result;
      }, []);
    }
    if (this.props.transfers.shuttle.showTimes) {
      times = this.props.transfers.shuttle.options.times.reduce((result, val) => {
        result.push({ value: val.id, label: val.options });
        return result;
      }, []);
    }
    const seatTypeHelp = (
      <Tooltip id="tooltip">
        <div className="text-left tooltipinfo" dangerouslySetInnerHTML={{ __html: help['seatType']['content'] }} />
      </Tooltip>
    );

    let arr = [];
    for (let i = 0; i < this.props.children; i++) {
      arr.push(
        <div key={i}>
          <h5 style={{ margin: '20px 0' }}>
            <strong>{`Child ${i + 1}`}</strong>
          </h5>
          <div>
            <Field
              name={`childAge${i}`}
              //type="number"
              //min="0"
              //max="15"
              type="select"
              selectData={childAges}
              component={renderField}
              label="Child Age"
              onFocus={() => handleBlur(`childAge${i}`)}
            />
            <Row>
              <Col xs={10}>
                <Field
                  name={`seatType${i}`}
                  type="select"
                  selectData={seatTypes}
                  component={renderField}
                  label="Child seat requirements"
                  onFocus={() => handleBlur(`seatType${i}`)}
                />
              </Col>
              <Col xs={2} style={{ marginTop: '18px', paddingLeft: '5px' }}>
                <OverlayTrigger trigger="click" placement="bottom" overlay={seatTypeHelp}>
                  <span className="fa-stack" style={{ color: '#7a7a7a' }}>
                    <i className="fa fa-circle-thin fa-stack-2x" />
                    <i className="fa fa-info fa-stack-1x" />
                  </span>
                </OverlayTrigger>
              </Col>
            </Row>
          </div>
        </div>
      );
    }

    return (
      <Form onSubmit={handleSubmit(onSubmit)}>
        {this.props.transfers.showFlightNumber ? (
          <Field
            name="flightNumber"
            type="text"
            component={renderField}
            label={this.props.transfers.flightNumberLabel}
            feedbackIcon={planeFeedbackIcon}
            onFocus={() => handleBlur('flightNumber')}
            //onBlur={() => RenderCheckbox.handleFieldBlur()}
          />
        ) : null}
        {this.props.transfers.showFlightTimeOverride ? (
          <label style={{ marginTop: '10px' }}>
            <Field
              name="flying"
              component={RenderCheckbox}
              type="checkbox"
              //onFocus={() => handleBlur('flying')}
              //onClick={() => handleBlur('flying')}
              withRef
              label={this.props.transfers.flightTimeOverrideLabel}
              handleBlur={this.props.handleBlur}
              ref={ref => (this.foo = ref)}
            />
          </label>
        ) : null}
        {this.props.transfers.fromAccommodation.show ? (
          <Field
            name="accommodationName"
            type="text"
            feedbackIcon={homeFeedbackIcon}
            component={renderField}
            label="FROM: Accommodation Name"
            onFocus={() => handleBlur('accommodationName')}
          />
        ) : null}
        {this.props.transfers.fromAccommodation.show ? (
          <Field
            name="accommodationAddress"
            type="text"
            feedbackIcon={homeFeedbackIcon}
            component={renderField}
            label="FROM: Accommodation Address"
            onFocus={() => handleBlur('accommodationAddress')}
          />
        ) : null}
        {this.props.transfers.toAccommodation.show ? (
          <Field
            name="toAccommodationName"
            type="text"
            feedbackIcon={homeFeedbackIcon}
            component={renderField}
            label="TO: Accommodation Name"
            onFocus={() => handleBlur('toAccommodationName')}
          />
        ) : null}
        {this.props.transfers.toAccommodation.show ? (
          <Field
            name="toAccommodationAddress"
            type="text"
            feedbackIcon={homeFeedbackIcon}
            component={renderField}
            label="TO: Accommodation Address"
            onFocus={() => handleBlur('toAccommodationAddress')}
          />
        ) : null}
        {this.props.transfers.shuttle.showTimes ? (
          <Field
            name="busNumber"
            type="select"
            component={renderField}
            selectData={times}
            label="Bus Number"
            onFocus={() => handleBlur('busNumber')}
          />
        ) : null}
        {this.props.transfers.shuttle.showFrom ? (
          <Field
            name="departureStop"
            type="select"
            component={renderField}
            selectData={stopsFrom}
            label="Bus Station"
            onFocus={() => handleBlur('departureStop')}
          />
        ) : null}
        {this.props.transfers.shuttle.showTo ? (
          <Field
            name="arrivalStop"
            type="select"
            component={renderField}
            selectData={stopsTo}
            label="Bus Station"
            onFocus={() => handleBlur('arrivalStop')}
          />
        ) : null}
        {arr}
        <div className="next-button">
          <Button bsSize="large" bsStyle="success" type="submit" className="next" onFocus={() => handleBlur('')}>
          <span>Next</span>
          </Button>
          <Button bsStyle="link" type="button" className="previous" onClick={previousPage}>
            <Glyphicon glyph="arrow-left" /> See previous screen
          </Button>
        </div>
      </Form>
    );
  }
}

export default reduxForm({
  onSubmit: () => val => console.log(val),
  enableReinitialize: false,
  keepDirtyOnReinitialize: false,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate,
  asyncValidate
})(WizardFormSecondPage);



// WEBPACK FOOTER //
// ./src/containers/QuotePage/TravelDetailsPanel/form/WizardFormSecondPage.js